import React from "react";
import { Link, useNavigate } from "@remix-run/react";
import { useAuth } from "~/lib/auth-context";

export interface AuthAwareLinkProps {
  to: string;
  requiresAuth?: boolean;
  authMessage?: string;
  children: React.ReactNode;
  className?: string;
  prefetch?: "intent" | "render" | "none";
  onClick?: (e: React.MouseEvent) => void;
}

export function AuthAwareLink({
  to,
  requiresAuth = false,
  authMessage = "",
  children,
  className,
  prefetch,
  onClick,
  ...props
}: AuthAwareLinkProps) {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  const handleAuthRequiredClick = (e: React.MouseEvent) => {
    if (!isAuthenticated && !loading) {
      e.preventDefault();
      if (onClick) onClick(e);

      // 로그인 안내 페이지로 이동 (redirect 파라미터 포함)
      navigate(
        `/auth-required?redirect=${encodeURIComponent(
          to
        )}&message=${encodeURIComponent(authMessage)}`
      );
    } else if (onClick) {
      onClick(e);
    }
  };

  // 인증이 필요하지만 로그인하지 않은 경우
  if (requiresAuth && !isAuthenticated && !loading) {
    return (
      <button
        onClick={handleAuthRequiredClick}
        className={`${
          className || ""
        } bg-transparent border-0 p-0 m-0 cursor-pointer inline appearance-none outline-none min-h-0 min-w-0`}
        style={{
          textDecoration: "inherit",
          lineHeight: "inherit",
          letterSpacing: "inherit",
        }}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <Link
      to={to}
      prefetch={prefetch}
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  );
}
